/**
 * chi tiết loại thu HĐSN và dịch vụ
 * bdanh 05.02.2023
 */
export default {
  /**
   * Học phí
   */
  Tuition: 1,
  /**
   * Viện phí
   */
  HospitalsFee: 2,
  /**
   * Nguồn thu khác
   */
  OtherRevenue: 3,
};
